module.exports = __webpack_public_path__ + "img/donante-edomex.c39fff24.jpg";